import React from 'react';
import Pie from '../common/new_graph/pie';
import colors from '../common/arrayColors';
import { localStoreFN } from '../../store/localStorage';

const failsPie = props => {
  const lang = localStoreFN().getItem('lang');

  return (
    <div className="pie-two">
      <div className="pie-indicator fails-filter">
        <div className="gravity-filter">
          <div className="arrow-filter-wraper">
            <div className="flex">
              <div>
                <span>{props.language.detail_waiting_times.detailTruck.gravity}:</span>
                <span id="severity-lower-case">{props.severity.toLowerCase()}</span>
              </div>

              <div className="dropdown">
                <i className="fas fa-sort-down" />
                <div className="dropdown-content">
                  <span onClick={props.handleClik} data-type={'Todas'} className="filter-item">
                    {props.language.detail_waiting_times.detailTruck.all}
                  </span>
                  {props.gravity
                    ? props.gravity.map((item, index) => (
                        <span
                          onClick={props.handleClik}
                          data-type={item.name}
                          className="filter-item"
                          key={index + 1}
                        >
                          {item.name.toLowerCase()}
                        </span>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-filter">
          <div className="arrow-filter-wraper">
            <div className="flex">
              <div>
                <span>{props.language.detail_waiting_times.detailTruck.form}:</span>
                <span>
                  {props.label.substring(0, 23)}
                  {props.label.substring(0, 25).length > 10 ? '...' : ''}
                </span>
              </div>

              <div className="dropdown-1">
                <i className="fas fa-sort-down" />
                <div className="dropdown-content">
                  {props.form
                    ? props.form.map((item, index) => (
                        <span
                          onClick={props.handleFormClick}
                          data-type={item.title}
                          data-value={item.id}
                          className="filter-item"
                          key={index + 1}
                        >
                          {item.title}
                        </span>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pie-gravity gravity-two">
        {/* pie gravity container */}
        <div className="pie">
          {/* pie element */}
          <Pie
            size={60}
            data={props.questionFailsData ? props.questionFailsData : []}
            width={130}
            height={160}
            animation={false}
            translate={false}
            name="question"
            value="value"
            colors={props.obj.form.severityFailsColor}
            language={lang}
          />
        </div>
        <div className="pie-label-gravity">
          {/* pie gravity labels */}
          <h4>{props.language.detail_waiting_times.detailTruck.failsDetail}</h4>
          <ul className="list-pie fails-pie">
            {props.questionFailsData.length > 0 ? (
              props.questionFailsData.map((item, index) => (
                <li key={index}>
                  {' '}
                  <span className="color" style={{ background: colors[index] }} />
                  <span className="qustion">{item.question}</span>
                </li>
              ))
            ) : (
              <li>
                <span className="qustion">
                  {props.language.detail_waiting_times.detailTruck.empty}
                </span>{' '}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  )
};

export default failsPie;



// WEBPACK FOOTER //
// ./source/client/components/detail_truck/failsPie.jsx